module.exports = __webpack_public_path__ + "static/media/plan-billing.81fcfd6b.svg";